'use client';

// import { useTranslations } from '@tszhong0411/i18n/client'
import { Button, useDeviceMediaQuery } from '@mcdougald/ui/src';
import { ArrowRight } from 'lucide-react';
import { FaSignInAlt } from 'react-icons/fa';

import { cn } from '@/libraries/tailwind/cn';
import { useDialogsStore } from '@/store/dialogs';

/**
 * Sign-in button at top right of layout
 */
const HeaderSignIn = () => {
  // const t = useTranslations();
  const { setIsSignInOpen } = useDialogsStore();
  const { isMobile } = useDeviceMediaQuery();

  if (isMobile) {
    return (
      <Button
        id="mobile-signup-button"
        data-umami-event="Mobile-Signup-Button"
        variant={'primary'}
        className={cn(
          `flex dark:text-primary self-center bg-linear-to-br font-extrabold cursor-pointer border-none mr-3`,
          'from-[#545d6d] via-[#303d53] to-[#1C2230]',
        )}
        size={'lg'}
        onClick={() => setIsSignInOpen(true)}
      >
        <FaSignInAlt size={16} />
      </Button>
    );
  }

  // const oldFrom = 'from-[#545d6d] via-[#303d53] to-[#1C2230]'

  return (
    <>
      <Button
        id="signup-button"
        data-umami-event="Signup-Button"
        variant={'primary'}
        className={cn(
          `!text-gray-900 flex dark:text-primary self-center bg-linear-to-br font-extrabold cursor-pointer border-none mr-3`,
          'from-[#f5f5f5] via-[#eaeaea] to-[#ffffff]',
        )}
        size={'lg'}
        onClick={() => setIsSignInOpen(true)}
      >
        {'Sign in'}
        <ArrowRight size={16} />
      </Button>
      {/*<span className="ml-2">{'To Leave a message'}</span>*/}
    </>
  );
};

export default HeaderSignIn;
